export default __webpack_public_path__ + "static/media/Stencil.fa5958f8.png";